import { jsx as _jsx } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { MemberFormField } from '../../subcomponents/member-form-field/member-form-field';
import { memberFormFieldPropsValidator } from '../../subcomponents/member-form-field/types/props';
import { withComponentWrapper } from '../../utils/with-component-wrapper';
import { defaultUpdateMemberDetailsFormFieldPropsProvider } from './types/props';
const b = bemClassBuilder('v-update-member-form-field');
const UpdateMemberDetailsFormField = observer(props => {
    return _jsx(MemberFormField, Object.assign({}, props, { classBuilder: b }));
});
UpdateMemberDetailsFormField.displayName = 'UpdateMemberDetailsFormField';
/**
 * The **Update Member Details Form Field** component will render a single field depending on the `name` prop value.
 */
export const UpdateMemberDetailsFormFieldComponent = withComponentWrapper(UpdateMemberDetailsFormField, defaultUpdateMemberDetailsFormFieldPropsProvider, memberFormFieldPropsValidator);
